import _defineProperty from "/codebuild/output/src3477731793/src/codestar-connections.us-west-2.amazonaws.com/git-http/603400662265/us-west-2/42625e79-deed-4f1d-8499-8b7906bc0d98/MarkAnthonyGroup/prismic-ca.whiteclaw.com/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/codebuild/output/src3477731793/src/codestar-connections.us-west-2.amazonaws.com/git-http/603400662265/us-west-2/42625e79-deed-4f1d-8499-8b7906bc0d98/MarkAnthonyGroup/prismic-ca.whiteclaw.com/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["field", "document", "linkResolver", "internalComponent", "externalComponent"],
  _excluded2 = ["href", "rel"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { jsx } from "react/jsx-runtime";
import * as React from "react";
import { asLinkAttrs } from './../_node_modules/@prismicio/client/dist/helpers/asLinkAttrs.js';
import "@prismicio/richtext";
import { devMsg } from "../lib/devMsg.js";
import { isInternalURL } from "../lib/isInternalURL.js";
var defaultComponent = "a";
var PrismicLink = React.forwardRef(function PrismicLink2(_ref, ref) {
  var field = _ref.field,
    doc = _ref.document,
    linkResolver = _ref.linkResolver,
    internalComponent = _ref.internalComponent,
    externalComponent = _ref.externalComponent,
    restProps = _objectWithoutProperties(_ref, _excluded);
  if (process.env.NODE_ENV === "development") {
    if (field) {
      if (!field.link_type) {
        console.error("[PrismicLink] This \"field\" prop value caused an error to be thrown.\n", field);
        throw new Error("[PrismicLink] The provided field is missing required properties to properly render a link. The link will not render. For more details, see ".concat(devMsg("missing-link-properties")));
      } else if (Object.keys(field).length > 1 && !("url" in field || "uid" in field || "id" in field)) {
        console.warn("[PrismicLink] The provided field is missing required properties to properly render a link. The link may not render correctly. For more details, see ".concat(devMsg("missing-link-properties")), field);
      }
    } else if (doc) {
      if (!("url" in doc || "id" in doc)) {
        console.warn("[PrismicLink] The provided document is missing required properties to properly render a link. The link may not render correctly. For more details, see ".concat(devMsg("missing-link-properties")), doc);
      }
    }
  }
  var _asLinkAttrs = asLinkAttrs(field !== null && field !== void 0 ? field : doc, {
      linkResolver: linkResolver,
      rel: typeof restProps.rel === "function" ? restProps.rel : void 0
    }),
    computedHref = _asLinkAttrs.href,
    computedRel = _asLinkAttrs.rel,
    attrs = _objectWithoutProperties(_asLinkAttrs, _excluded2);
  var rel = computedRel;
  if ("rel" in restProps && typeof restProps.rel !== "function") {
    rel = restProps.rel;
  }
  var href = ("href" in restProps ? restProps.href : computedHref) || "";
  var InternalComponent = internalComponent || defaultComponent;
  var ExternalComponent = externalComponent || defaultComponent;
  var Component = href && isInternalURL(href) ? InternalComponent : ExternalComponent;
  return /* @__PURE__ */jsx(Component, _objectSpread(_objectSpread(_objectSpread({
    ref: ref
  }, attrs), restProps), {}, {
    href: href,
    rel: rel
  }));
});
export { PrismicLink, defaultComponent };